import TextToolTip from "@lhd/components/TextToolTip";
import { Column } from "ag-grid-community";

interface Props {
  displayName: string;
  column: Column;
}

const HeaderDefault = (props: Props) => {
  return (
    <div
      className="ag-header-cell-text"
      style={{
        maxWidth: "100%",
        display: "flex",
        alignItems: "center",
        flexWrap: "nowrap",
      }}
    >
      <TextToolTip style={{ flex: 1, minWidth: 0 }}>
        {props.displayName}
      </TextToolTip>
      {(props.column?.getColDef() as any)?.isRequired && (
        <span style={{ color: "red", marginLeft: "2px", flexShrink: 0 }}>
          *
        </span>
      )}
    </div>
  );
};

export default HeaderDefault;
